import React, { useState } from "react"
import moment from "moment"
import { PreviousShiftEvent } from "@type/workMonitor.types"
import { Image } from "antd-v5"
import { Icon, SignedUrlForImage, Tooltip } from "components/index"
import { twMerge } from "tailwind-merge"

interface Props {
	events: PreviousShiftEvent
	containerClass?: string
	shiftStatusColor: string
}

const ShiftEventCard: React.FC<Props> = ({ events, shiftStatusColor, containerClass }) => {
	const [showDropDown, setShowDropDown] = useState<boolean>(false)
	const handleDropDown = () => {
		setShowDropDown(prev => !prev)
	}

	const googleMapsUrl = `https://www.google.com/maps?q=${events.geo?.coordinates[1]},${events.geo?.coordinates[0]}`

	const performedUser = events?.user ? `${events?.user.firstName} ${events?.user.lastName}` : events.source

	return (
		<div className="m-2 cursor-pointer rounded-md border-[0.75px] border-dark/20 px-2 pb-2 font-semibold">
			<div className="flex flex-row items-center pt-2 3xl:flex-row" onClick={handleDropDown}>
				<div>
					<Icon name={showDropDown ? "dropdownArrow" : "dropRightArrow"} size={20} color="black" />
				</div>
				<div className="flex w-full flex-col items-center justify-center 3xl:flex-row 3xl:justify-between">
					<div className="flex items-center space-x-2">
						<div
							className={twMerge(
								`h-fit rounded-2 text-white ${shiftStatusColor} px-2 text-sm font-semibold`,
							)}
						>
							{events.status}
						</div>
						{!!events?.isEventMissed && (
							<div className="flex h-6 w-6 items-center justify-center">
								<Tooltip message="Missed!">
									<Icon name="cross" size={20} color="danger" />
								</Tooltip>
							</div>
						)}
					</div>

					<div className="flex items-center space-x-0 sm:flex-col 3xl:flex-row 3xl:space-x-5">
						{!events?.isEventMissed && (
							<span className="col-span-4">
								Event Time: {moment(events?.eventTime || events.createdAt).format("HH:mm")}
							</span>
						)}
						<span className="col-span-4">
							Due Time:{" "}
							{moment(events.dueTime).isValid() ? moment(events.dueTime).format("HH:mm") : events.dueTime}
						</span>
					</div>
				</div>
			</div>

			<div className={`flex flex-col space-y-2 py-2 ${showDropDown ? "visible" : " hidden"} `}>
				{events.geo?.coordinates.length ? (
					<span>
						Location:{" "}
						<a href={googleMapsUrl} target="_blank" rel="noopener noreferrer">
							View on map
						</a>
					</span>
				) : undefined}

				{events.images?.length && showDropDown ? (
					<div className={`grid grid-cols-4 gap-x-3 p-2 ${containerClass?.length ? " grid-cols-7" : ""}`}>
						<Image.PreviewGroup>
							{events.images?.map((imageUrl, index) => {
								return (
									<SignedUrlForImage path={imageUrl} key={`loadedImage_${index}`}>
										{(image, loading) => (
											<div>
												{loading ? (
													<div className={`flex items-center justify-center`}>
														<Icon
															name="spinner"
															size={15}
															color="black"
															className="animate-spin"
														/>
													</div>
												) : (
													<Image loading="lazy" src={image} />
												)}
											</div>
										)}
									</SignedUrlForImage>
								)
							})}
						</Image.PreviewGroup>
					</div>
				) : (
					<></>
				)}
				{performedUser && <span>{`Performed By: ${performedUser} `}</span>}
				{!!events.comment?.length && <span>Comment: {events.comment} </span>}
			</div>
		</div>
	)
}

export default ShiftEventCard
